import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

const AdminOpsContext = createContext(null);

export function AdminOpsProvider({ children }) {
  const { user, api } = useAuth();
  const [opsData, setOpsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const isAdmin = user?.role === 'admin';

  const refreshOps = useCallback(async () => {
    if (!isAdmin) return;
    setLoading(true);
    try {
      const res = await api.get('/api/admin/operations');
      setOpsData(res.data);
    } catch { /* not admin or error */ }
    finally { setLoading(false); }
  }, [isAdmin, api]);

  useEffect(() => {
    if (isAdmin) refreshOps();
  }, [isAdmin, refreshOps]);

  // Auto-refresh every 60 seconds
  useEffect(() => {
    if (!isAdmin) return;
    const interval = setInterval(refreshOps, 60000);
    return () => clearInterval(interval);
  }, [isAdmin, refreshOps]);

  return (
    <AdminOpsContext.Provider value={{ opsData, loading, refreshOps, isAdmin }}>
      {children}
    </AdminOpsContext.Provider>
  );
}

export function useAdminOps() {
  return useContext(AdminOpsContext) || { opsData: null, loading: false, isAdmin: false, refreshOps: () => {} };
}
